import React, { useEffect, useState } from 'react'
import './Settings.css'
import { useNavigate } from 'react-router'

function Settings() {
  const navigate = useNavigate()

  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [loggedUser, setLoggedUser] = useState()

  const toggleSearch = () => {
    setIsSearchVisible(!isSearchVisible)
  }

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo) {
      setLoggedUser(userInfo)
    }
  }, [])

  return (
    <>
      <div
        class="appHeader text-light"
        style={{ boxShadow: 'none', justifyContent: 'flex-end' }}
      >
        <div
          className={`wide-block pt-1 pb-1 position-sticky searchSection ${
            isSearchVisible ? 'search-index' : ''
          }`}
        >
          <form className="search-form">
            <div
              className={`form-group searchbox not-empty
          absolute right-0 top-0 flex items-center
          transition-all duration-300 ease-in-out
          ${
            isSearchVisible
              ? 'w-full opacity-100 '
              : 'w-0 -right-full opacity-0 d-none'
          }
        `}
            >
              <input
                type="text"
                className="form-control"
                placeholder="Search Conversations"
                autoFocus={isSearchVisible}
              />
              <i className="input-icon">
                <ion-icon
                  name="search-outline"
                  role="img"
                  className="md hydrated"
                  aria-label="search outline"
                ></ion-icon>
              </i>
            </div>
          </form>
        </div>

        <div class="left">
          <a
            href="#"
            class="headerButton goBack"
            onClick={() => navigate('/dashboard')}
          >
            <ion-icon
              name="arrow-back-outline"
              role="img"
              class="md hydrated"
              aria-label="arrow-back-outline"
            ></ion-icon>
          </a>
        </div>
        <div class="Title" style={{ right: '88.5rem' }}>
          Settings
        </div>
        <div class="right" onClick={toggleSearch}>
          <a href="#" class="headerButton">
            <ion-icon
              name="search-outline"
              role="img"
              class="md hydrated"
              aria-label="search-outline"
            ></ion-icon>
          </a>
        </div>
      </div>
      <div id="appCapsule">
        <div class="section mt-2 sec" onClick={() => navigate('/myprofile')}>
          <div class="profile-head">
            <div>
              {loggedUser && (
                <div className="d-flex flex-row align-items-center">
                  <div class="avatar">
                    <img
                      src={loggedUser.pic}
                      alt="avatar"
                      class="imaged w64 rounded"
                    />
                  </div>
                  <div class="in">
                    <h3 class="name">{loggedUser.name}</h3>
                    <h5 class="subtext">SkyQ Tech</h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div>
          <ul class="listview image-listview">
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="key-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Account
                    <footer>Security notifications, change number</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="lock-closed-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Privacy
                    <footer>Block contect, Disappearing messages</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="man-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Avatar
                    <footer>Create, edit, Profile photo</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="heart-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Favorites
                    <footer>Add, reorder, remove</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Chats
                    <footer>Theme, Wallpaper, chat history</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="notifications-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Notifications
                    <footer>Message, group & call tones</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="cloud-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Storage and data
                    <footer>Network usage, auto-download</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="globe-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    App language
                    <footer>English (device's language)</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="help-circle-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>
                    Help
                    <footer>Help center, contect us, Privacy policy</footer>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="people-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>Invite afriend</div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="sync-outline"></ion-icon>
                </div>
                <div class="in">
                  <div>App Update</div>
                </div>
              </div>
            </li>
            <div style={{ padding: '24px' }}>Also from Meta</div>
            <li>
              <div class="item">
                <div class="icon-box ">
                  <ion-icon name="logo-instagram"></ion-icon>
                </div>
                <div class="in">
                  <div>Open Instagram</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Settings
